import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressHintbox.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { AddressSelectOptions } from "../TravelBookingListTypes";
import SelectBox from '../../../../moreCore/UI/SelectBox/SelectBox';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';

class AddressHintbox extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private addressTypeSelectbox: MdsLax<InstanceType<typeof SelectBox>>;
    private addressHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private assignButton: HTMLButtonElement;

    private clickFunction: Function;

    setClickFunction(clickFunction: Function): void {
        this.clickFunction = clickFunction;
        this.assignButton.addEventListener("click", (ev) => clickFunction());
    }

    private _setupAddressTypeSelectBox(): void {
        var addressTypes = Object.keys(AddressSelectOptions);

        addressTypes.forEach((type) => {
            this.addressTypeSelectbox.addOption(
                type,
                this.translate(AddressSelectOptions[type]),
                true
            );
        });
        this.addressTypeSelectbox.setBlankOption("", this.translate("TravelBookingForm_Select_ChooseAddressType"));
        this.addressTypeSelectbox.constructOptions();
    }

    private _onAddressTypeChange(e): void {
        if (e === "") {
            this.disableNode(this.addressHintbox, true);
        } else {
            switch (e) {
                case "related_musicians":
                case "related_addresses":
                    this.addressHintbox.enableSelectEntityDialog(true);
            }


            this.disableNode(this.addressHintbox, false);
            this.addressHintbox.removeAdditionalRequestParam("type");
            this.addressHintbox.addAdditionalRequestParameter("type", e);
        }
    }

    private _onAddressChange(e): void {
        this.emit("change", e);
    }

    public reset() {
        this.addressTypeSelectbox.setValue("");
        this.addressHintbox.setValue("", true);
    }

    public getValue(mode?: "entity" | "value" | "plaintext") {
        return this.addressHintbox.getValue(mode);
    }

    public getGDispNameFirstname() {
        var entity = this.addressHintbox.getValue("entity");
        if (entity) {
            return entity.gDisp_Name_Firstname;
        } else {
            return this.addressHintbox.getValue("plaintext");
        }
    }

    public setValue(newValue: string | object, bSuppressChange?: boolean) {
        this.addressHintbox.setValue(newValue, bSuppressChange)
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.disableNode(this.addressHintbox);
        this._setupAddressTypeSelectBox();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AddressHintbox);